import { render, staticRenderFns } from "./search.vue?vue&type=template&id=5651126d&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=5651126d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651126d",
  null
  
)

export default component.exports